import { BaseApi } from "../utils/request";
import type {
  FirstRechargeStagedSnapshot,
  FirstRechargeStagedClaimOutcome,
} from "../modules/firstRechargeStaged/types";

export interface ClaimBody {
  rechargeRecordId: string;
  targetIndex: number;
  stageId?: string;
}

export interface ClaimAllBody {
  rechargeRecordId: string;
}

/**
 * 首充分批领取相关 API
 */
class FirstRechargeStagedApi extends BaseApi {
  async fetchSnapshot(): Promise<FirstRechargeStagedSnapshot> {
    const response = await this.post<FirstRechargeStagedSnapshot, true>(
      "/api/first_recharge_staged/snapshot",
      {},
      { alert: false }
    );
    return response.data.model;
  }

  async claim(body: ClaimBody): Promise<FirstRechargeStagedClaimOutcome> {
    const response = await this.post<FirstRechargeStagedClaimOutcome, true>(
      "/api/first_recharge_staged/claim",
      body,
      { alert: false }
    );
    return response.data.model;
  }

  async claimAll(body: ClaimAllBody): Promise<FirstRechargeStagedClaimOutcome> {
    const response = await this.post<FirstRechargeStagedClaimOutcome, true>(
      "/api/first_recharge_staged/claim_all",
      body,
      { alert: false }
    );
    return response.data.model;
  }

  async autoAfterEndAck(
    body: Record<string, string | undefined> = {}
  ): Promise<void> {
    await this.post("/api/first_recharge_staged/auto_after_end_ack", body, {
      alert: false,
    });
  }
}

export const firstRechargeStagedApi = new FirstRechargeStagedApi();
